export default "__VITE_ASSET__C5y2zEWz__"